module.exports = __webpack_public_path__ + "img/mail.424e2043.svg";